import React, { useEffect, useState } from "react";

// Local imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";
import { route } from "../global/route.global";
import { months } from "../global/var.global";
import Img from "../widgets/Img";

// Live imports
import axios from "axios";
import parse from "html-react-parser";
import moment from "moment";
import Loader from "react-loader-spinner";

import { withRouter, NavLink as Link } from "react-router-dom";
import NewsAdvisoryItem from "./news-advisories-item";

function NewsAdvisories() {
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [lists, setLists] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    getLists();
  }, []);

  const getLists = async () => {
    await axios
      .get(route.root.announcements + "/advisory")
      .then(async (res) => {
        // console.log(res.data.data.announcements);
        setLists(res.data.data.announcements);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>
                  News and <span>Advisories</span>
                </h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclassname="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/news/advisories" activeclassname="active">
                          Advisories
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-wrapper pt-5">
        <div className="container">
          {/* <div className="section_heading text-right">
            <p>
              <span className="mr-3">
                <i className="fa fa-filter"></i> Filter by: <span>Month</span>{" "}
              </span>
              {searchOpen ? (
                <input
                  type="text"
                  className="mr-2 searchBox form-control"
                  placeholder="Type here..."
                />
              ) : null}
              <span className="hover-pointer" onClick={toggleSearch}>
                {searchOpen ? (
                  <i className="fa fa-close mr-2"></i>
                ) : (
                  <i className="fa fa-search mr-2"></i>
                )}
                Search{" "}
              </span>
            </p>
          </div> */}

          <div className="row">
            {isLoading ? (
              <div className="container">
                <div className="text-center">
                  <Loader
                    type="TailSpin"
                    color="#f10d08"
                    height={70}
                    width={70}
                    timeout={9000}
                  />
                  <h6>LOADING...</h6>
                </div>
              </div>
            ) : null}

            <section className="inner-page-wrapper faq-wrapper">
              <div className="container">
                <div className="accordion" id="accordionAdvisory">
                  {lists.map((i, k) => {
                    return <NewsAdvisoryItem item={i} key={k} />;
                  })}
                </div>
              </div>
            </section>
          </div>

          {/* <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/images/home/seal1.jpg" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/images/home/data-privacy.pdf"
                      target="_blank"
                    >
                      Data Privacy
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/assets/images/home/data-privacy.pdf">
                            Main Office
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/images/home/data-privacy.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/news/notice-of-election.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/news/notice-of-election.pdf"
                      target="_blank"
                    >
                      Notice of Election
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/assets/uploads/news/notice-of-election.pdf">
                            Main Office
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/news/notice-of-election.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/news/OGCS-PROM 1606-2025. NVH 2025-167 RC 16Sept2025.pdf"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/news/OGCS-PROM 1606-2025. NVH 2025-167 RC 16Sept2025.pdf"
                      target="_blank"
                    >
                      ERC CASE NO. 2025-167 RC
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/assets/uploads/news/OGCS-PROM 1606-2025. NVH 2025-167 RC 16Sept2025.pdf">
                            Main Office
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/news/OGCS-PROM 1606-2025. NVH 2025-167 RC 16Sept2025.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/news/OGCS-PROM 1606-2025. ATTACHMENT 2025-167 RC 16Sept2025.pdf"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/news/OGCS-PROM 1606-2025. ATTACHMENT 2025-167 RC 16Sept2025.pdf"
                      target="_blank"
                    >
                      ERC CASE NO. 2025-167 RC (ATTACHMENT 2025-167)
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/assets/uploads/news/OGCS-PROM 1606-2025. ATTACHMENT 2025-167 RC 16Sept2025.pdf">
                            Main Office
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/news/OGCS-PROM 1606-2025. ATTACHMENT 2025-167 RC 16Sept2025.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/news/OGCS-PROM 1606-2025. ORDR 2025-167 RC 16Sept2025.pdf"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/news/OGCS-PROM 1606-2025. ORDR 2025-167 RC 16Sept2025.pdf"
                      target="_blank"
                    >
                      ERC CASE NO. 2025-167 RC (ORDR 2025-167)
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/assets/uploads/news/OGCS-PROM 1606-2025. ORDR 2025-167 RC 16Sept2025.pdf">
                            Main Office
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/news/OGCS-PROM 1606-2025. ORDR 2025-167 RC 16Sept2025.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>

      <CTAStrip />
    </>
  );
}

export default withRouter(NewsAdvisories);
